export const LINKEDCALENDAR_ENTRY_TYPE = 'LinkedCalendarEntry:#Exchange';
